import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, FormFeedback, DropdownItem } from 'reactstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash.debounce';
import { showErrorToast } from '../../../../components/Common/CustomToast';
import { ADD_QUOTE_MODAL_CHARGES, REMOVE_QUOTE_MODAL_CHARGES } from "../../../../store/Sales/Quotation/actiontype";
import { pickup_icon, pickup_icon5 } from '../../../../assets/images';


const ContainerRow = ({ index, container, isApplyingBid, containerData, onContainerTypeChange, containerTypeOptions, formik, onRemove, isLast, formError }) => {
    const errors = formik.errors.containers?.[index] || {};
    const touched = formik.touched.containers?.[index] || {};
    return (
        <div className='charges_wrap'>
            <Row className="mt-2">
                <Col md={3}>
                    <label className="form-label">Container Type<span
                        className='required_star'>*</span></label>
                    <div className="field_wrap">
                        <Select
                            name={`containers[${index}].containerType`}
                            value={formik.values.containers[index].containerType}
                            onChange={(value) => {
                                onContainerTypeChange(value, index, 'component');
                                formik.setFieldValue(`containers[${index}].containerType`, value);
                            }}
                            placeholder="Select Container Type"
                            options={containerTypeOptions}
                            classNamePrefix="form-select"
                            menuPlacement="auto"
                            isDisabled={isApplyingBid ? true : false}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: (formError[index]?.containerType || errors?.containerType) ? 'red' : 'grey',
                                    backgroundColor: isApplyingBid ? 'white' : 'white',
                                    cursor: isApplyingBid ? 'not-allowed' : 'default',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: 'black', // 👈 your custom text color
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: '#aaa', // optional placeholder color
                                })
                            }}
                        />
                        {(formError[index]?.containerType || errors?.containerType) && (<div className="text-danger">{formError[index]?.containerType || errors?.containerType}</div>)}
                    </div>
                </Col>
                <Col md={3}>
                    <label className="form-label">Quantity<span
                        className='required_star'>*</span></label>
                    <div className="field_wrap">
                        <Input
                            type="number"
                            minLength={1}
                            maxLength={100}
                            name={`containers[${index}].quantity`}
                            value={formik.values.containers[index].quantity}
                            placeholder="Enter quantity..."
                            className={(formError[index]?.quantity || errors?.quantity) ? 'error' : ''}
                            readOnly={isApplyingBid ? true : false}
                            onChange={(e) => {
                                const value = e.target.value;
                                onContainerTypeChange(value, index, 'unit');
                                formik.setFieldValue(`containers[${index}].quantity`, value);
                            }}
                        />
                        {(formError[index]?.quantity || errors?.quantity) && (<div className="text-danger">{formError[index]?.quantity || errors?.quantity}</div>)}
                    </div>
                </Col>
                <Col md={3}>
                    <label className="form-label">Weight (MT)</label>
                    <div className="field_wrap">
                        <Input
                            type="number"
                            minLength={1}
                            maxLength={100}
                            name={`containers[${index}].weight`}
                            placeholder="Enter Weight..."
                            value={formik.values.containers[index].weight}
                            className={(formError[index]?.weight || errors?.weight) ? 'error' : ''}
                            readOnly={isApplyingBid ? true : false}
                            onChange={formik.handleChange}
                        />
                        {(formError[index]?.weight || errors?.weight) && (<div className="text-danger">{formError[index]?.weight || errors?.weight}</div>)}
                    </div>
                </Col>
                {!isApplyingBid && (
                    <Col className="col-1 mt-4 d-flex align-items-start">
                        <div className="d-flex gap-2">
                            {isLast ? (
                                <>
                                    {index > 0 && (
                                        <button className="btn border" onClick={() => onRemove(index)}>
                                            <i className="bx bx-trash fs-5 align-middle text-danger"></i>
                                        </button>
                                    )}
                                    <Button color="light" onClick={formik.handleAddContainer}>
                                        <i className="bx bx-plus-circle"></i>
                                    </Button>
                                </>
                            ) : (
                                <button className="btn border" onClick={() => onRemove(index)}>
                                    <i className="bx bx-trash fs-5 align-middle text-danger"></i>
                                </button>
                            )}
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
};

ContainerRow.displayName = "ContainerRow";

const AirContainerRow = ({ index, item, isApplyingBid, shipmentDetailsValHandler, weightUnit, onRemove, isLast, formik }) => {
    return (
        <div className='charges_wrap'>
            <Row className="mt-2">
                <Col md={2}>
                    <div className="input_field">
                        <label htmlFor={`no_unit_${index}`} className="form-label"> No. Of
                            Pieces </label>
                        <input
                            type="number"
                            readOnly={isApplyingBid}
                            disabled={isApplyingBid}
                            value={item?.no_unit || ""}
                            className="form-control"
                            id={`no_unit_${index}`}
                            onChange={(e) => {
                                shipmentDetailsValHandler(e.target.value, "no_unit", index, true);
                            }}
                        />
                    </div>
                </Col>
                <Col md={2}>
                    <div className="input_field">
                        <label htmlFor={`weightPerUnit_${index}`} className="form-label"> Weight Per Uni(KG)</label>
                        <input
                            type="number"
                            readOnly={isApplyingBid}
                            disabled={isApplyingBid}
                            value={item?.weightPerUnit || ""}
                            className="form-control"
                            id={`weightPerUnit_${index}`}
                            onChange={(e) => {
                                shipmentDetailsValHandler(e.target.value, "weightPerUnit", index, true);
                            }}
                        />
                    </div>
                </Col>
                <Col >
                    <div className='container_combine_drop_wrap'>
                        <div className="common_dropdown_wrap container_drop_wrap" style={{ padding: "0", }}>
                            <div className="dimention_field mt-0">
                                <p className="form-label">
                                    Dimensions (L×W×H per unit)
                                </p>
                                <div className="input_field_wrap d-flex">
                                    <div className="input_field dimention_l">
                                        <input
                                            type="number"
                                            readOnly={isApplyingBid}
                                            disabled={isApplyingBid}
                                            value={item?.dimensions_l || ""}
                                            className="form-control"
                                            id={`dimensions_l_${index}`}
                                            onChange={(e) => {
                                                shipmentDetailsValHandler(e.target.value, "dimensions_l", index, true);
                                            }}
                                        />
                                    </div>
                                    <div className="input_field dimention_w">
                                        <input
                                            type="number"
                                            readOnly={isApplyingBid}
                                            disabled={isApplyingBid}
                                            value={item?.dimensions_w || ""}
                                            className="form-control"
                                            id={`dimensions_w_${index}`}
                                            onChange={(e) => {
                                                shipmentDetailsValHandler(e.target.value, "dimensions_w", index, true);
                                            }}
                                        />
                                    </div>
                                    <div className="input_field dimention_h">
                                        <input
                                            type="number"
                                            readOnly={isApplyingBid}
                                            disabled={isApplyingBid}
                                            value={item?.dimensions_h || ""}
                                            className="form-control"
                                            id={`dimensions_h_${index}`}
                                            onChange={(e) => {
                                                shipmentDetailsValHandler(e.target.value, "dimensions_h", index, true);
                                            }}
                                        />
                                    </div>
                                    <div className="input_field">
                                        <UncontrolledDropdown>
                                            <DropdownToggle
                                                className="btn btn-link dimention_drop d-flex justify-content-between"
                                                tag="a" disabled>
                                                {item?.dimensions_unit || "CM"}
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-end">
                                                <DropdownItem
                                                    className={`${weightUnit === "KG" ? "disabled" : ""}`}
                                                    onClick={() => {
                                                        shipmentDetailsValHandler("IN", "dimensions_unit", index, true);
                                                    }}
                                                > IN </DropdownItem>
                                                <DropdownItem
                                                    className={`${weightUnit === "Lbs" ? "disabled" : ""}`}
                                                    onClick={() => {
                                                        shipmentDetailsValHandler("CM", "dimensions_unit", index, true);
                                                    }}
                                                > CM </DropdownItem>
                                                <DropdownItem
                                                    className={`${weightUnit === "Lbs" ? "disabled" : ""}`}
                                                    onClick={() => {
                                                        shipmentDetailsValHandler("MM", "dimensions_unit", index, true);
                                                    }}
                                                > MM </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Col>
                <Col className="col-1 mt-4 d-flex align-items-start">
                    <div className="d-flex gap-2">
                        {!isApplyingBid && (
                            <Col className="col-1 mt-4 d-flex align-items-start">
                                <div className="d-flex gap-2">
                                    {isLast ? (
                                        <>
                                            {index > 0 && (
                                                <button className="btn border" onClick={() => onRemove(index)}>
                                                    <i className="bx bx-trash fs-5 align-middle text-danger"></i>
                                                </button>
                                            )}
                                            <Button color="light" onClick={formik.handleAddAirContainer}>
                                                <i className="bx bx-plus-circle"></i>
                                            </Button>
                                        </>
                                    ) : (
                                        <button className="btn border" onClick={() => onRemove(index)}>
                                            <i className="bx bx-trash fs-5 align-middle text-danger"></i>
                                        </button>
                                    )}
                                </div>
                            </Col>
                        )}

                    </div>
                </Col>
            </Row>
        </div>
    )
}

AirContainerRow.displayName = "AirContainerRow";

const ShipmentDetails = ({ tabName, shipmentDetailsFormik, onContainerTypeChange, isApplyingBid, isAdditionalCharge }) => {
    const dispatch = useDispatch();
    const { activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const { cargoType_data, container_data, UOM_weight_data, currency_data, commodity_data } = useSelector((state) => state?.globalReducer);
    const { instantRateLocation, incoterm, airLocation } = useSelector((state) => state.instantRate);
    const [isSubOpen, setIsSubOpen] = useState(false);
    const [containerTypeOptions, setContainerTypeOptions] = useState([]);
    const [filteredCount, setFilteredCount] = useState(0);
    const [incoTermsCount, setIncoTermsCount] = useState(0);
    const [classHazardous, setClassHazardous] = useState(0);
    const [formError, setFormError] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef(null);

    useEffect(() => {
        setFilteredCount(commodity_data.length);
    }, [commodity_data]);

    useEffect(() => {
        setIncoTermsCount(incoterm.length);
    }, [incoterm]);

    useEffect(() => {

        const cargo = cargoType_data.find(data => data.id === shipmentDetailsFormik?.values?.cargoType?.id);
        const containerTypes = cargo?.cargoContainerMappings?.map(type => ({
            value: type?.oceanContainer?.id ?? '',
            label: type?.oceanContainer?.name ?? ''
        })) ?? [];

        setContainerTypeOptions(containerTypes);

        // Initialize airContainers array if it doesn't exist
        if (!shipmentDetailsFormik.values.airContainers) {
            shipmentDetailsFormik.setFieldValue('airContainers', [{
                no_unit: '',
                weightPerUnit: '',
                dimensions_l: '',
                dimensions_w: '',
                dimensions_h: '',
                dimensions_unit: 'CM',
                v_weight: ''
            }]);
        }
    }, []);

    const handleAddContainer = async () => {
        const errors = await shipmentDetailsFormik.validateForm();
        const containerErrors = errors?.containers;
        setFormError([]);

        const isValid =
            Array.isArray(containerErrors) &&
            containerErrors.some((err) => err?.containerType || err?.quantity);

        if (!isValid) {
            shipmentDetailsFormik.setFieldValue('containers', [...shipmentDetailsFormik.values.containers, { containerType: '', quantity: '', weight: '' }]);
            let id = 'quote_0';
            let charge_name = 'FREIGHT_CHARGES';
            dispatch({ type: ADD_QUOTE_MODAL_CHARGES, payload: { id, charge_name, value: true, name: 'isDefault' } })
        } else {
            if (containerErrors !== undefined && Array.isArray(containerErrors)) {
                containerErrors.map((item, index) => {
                    //console.log(item, index);
                    setFormError(prev => {
                        const newErrors = [...prev];
                        newErrors[index] = item; // assuming item[index] contains the error for that index
                        return newErrors;
                    });
                })
            }
        }
    };

    const handleAddAirContainer = () => {
        shipmentDetailsFormik.setFieldValue('airContainers', [
            ...shipmentDetailsFormik.values.airContainers,
            {
                no_unit: '',
                weightPerUnit: '',
                dimensions_l: '',
                dimensions_w: '',
                dimensions_h: '',
                dimensions_unit: 'CM',
                v_weight: ''
            }
        ]);
    };

    shipmentDetailsFormik.handleAddContainer = handleAddContainer; // Expose to subcomponent
    shipmentDetailsFormik.handleAddAirContainer = handleAddAirContainer; // Expose to subcomponent

    const handleRemoveContainer = (index) => {
        const newContainers = shipmentDetailsFormik.values.containers.filter((_, i) => i !== index);
        let id = 'quote_0';
        let header = 'FREIGHT_CHARGES';
        dispatch({ type: REMOVE_QUOTE_MODAL_CHARGES, payload: { index, id, header } })
        shipmentDetailsFormik.setFieldValue('containers', newContainers.length > 0 ? newContainers : [{ containerType: null, quantity: '', weight: '' }]);
    };

    const handleRemoveAirContainer = (index) => {
        const newAirContainers = shipmentDetailsFormik.values.airContainers.filter((_, i) => i !== index);
        shipmentDetailsFormik.setFieldValue('airContainers', newAirContainers.length > 0 ? newAirContainers : [{
            no_unit: '',
            weightPerUnit: '',
            dimensions_l: '',
            dimensions_w: '',
            dimensions_h: '',
            dimensions_unit: 'CM',
            v_weight: ''
        }]);
    };

    const handleCargoTypeChange = (item) => {
        shipmentDetailsFormik.setFieldValue('cargoType', item);
        shipmentDetailsFormik.setFieldTouched('cargoType', true);
        if (item.value === 'GENERAL') {
            let id = 'quote_0';
            let charge_name = 'FREIGHT_CHARGES';
            dispatch({ type: ADD_QUOTE_MODAL_CHARGES, payload: { id, charge_name, value: true, name: 'isDefault' } })
        }

        const cargo = cargoType_data.find(data => data.id === item.id);
        const containerTypes = cargo?.cargoContainerMappings?.map(type => ({
            value: type?.oceanContainer?.id ?? '',
            label: type?.oceanContainer?.name ?? ''
        })) ?? [];

        setContainerTypeOptions(containerTypes);
    };

    const commodityOptions = useCallback(
        debounce((inputValue, callback) => {
            const filtered = commodity_data.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()));
            callback(filtered);
        }, 300),
        [commodity_data]
    );

    const oceanCargoOptions = useMemo(() => cargoType_data.filter(data => data.transportMode === "OCEAN"), [cargoType_data]);

    const locationOptions = useMemo(() => {
        // Choose location data based on tabName
        const locationData = tabName === 'FCL' ? instantRateLocation : airLocation;

        // Handle empty or undefined data
        if (!locationData || !Array.isArray(locationData) || locationData.length === 0) {
            return [];
        }

        // Map the selected location data to options format based on tab type
        try {
            if (tabName === 'FCL') {
                return locationData.map(location => ({
                    value: location.id?.toString() || '',
                    label: `${location.code && location.code !== 'NA' ? `${location.code}-` : ''}${location.name || ''}`,
                    locationType: location.locationType || ''
                }));
            } else {
                // For Air locations, handle different data structure
                return locationData.map(location => {
                    // Check if the location already has the right format
                    if (location.label && (location.value || location.id)) {
                        return {
                            value: location.id?.toString() || '',
                            label: location.label || '',
                            id: location.id?.toString() || (location.value?.toString() || '')
                        };
                    } else {
                        // Fallback to a similar format as FCL if structure is different
                        return {
                            value: location.id?.toString() || '',
                            label: `${location.code && location.code !== 'NA' ? `${location.code}-` : ''}${location.name || location.label || ''}`,
                            id: location.id?.toString() || ''
                        };
                    }
                });
            }
        } catch (error) {
            console.error('Error mapping location options:', error);
            return [];
        }
    }, [instantRateLocation, airLocation, tabName]);

    // Memoize frequently used location options to avoid recalculating on every render
    const memoizedLocationOptions = useMemo(() => {
        return locationOptions.map(option => ({
            ...option,
            searchLabel: option.label.toLowerCase() // Pre-compute lowercase for faster filtering
        }));
    }, [locationOptions]);

    const loadPolOptions = useCallback(
        debounce((inputValue, callback) => {
            const selectedPOD = shipmentDetailsFormik.values.location_to?.value;
            const searchTerm = inputValue.toLowerCase();

            // Early return for empty input to show all options
            if (!searchTerm) {
                const topOptions = memoizedLocationOptions
                    .slice(0, 100) // Limit to first 100 options for better performance
                    .map(option => ({
                        ...option,
                        isDisabled: option.value === selectedPOD
                    }));
                callback(topOptions);
                return;
            }

            // Use more efficient filtering approach
            const filtered = memoizedLocationOptions
                .filter(option => option.searchLabel.includes(searchTerm))
                .slice(0, 100) // Limit results for better performance
                .map(option => ({
                    ...option,
                    isDisabled: option.value === selectedPOD
                }));

            callback(filtered);
        }, 500), // Increased debounce time for better performance
        [memoizedLocationOptions, shipmentDetailsFormik.values.location_to?.value]
    );

    const loadPodOptions = useCallback(
        debounce((inputValue, callback) => {
            const selectedPOL = shipmentDetailsFormik.values.location_from?.value;
            const searchTerm = inputValue.toLowerCase();

            // Early return for empty input to show all options
            if (!searchTerm) {
                const topOptions = memoizedLocationOptions
                    .slice(0, 100) // Limit to first 100 options for better performance
                    .map(option => ({
                        ...option,
                        isDisabled: option.value === selectedPOL
                    }));
                callback(topOptions);
                return;
            }

            // Use more efficient filtering approach
            const filtered = memoizedLocationOptions
                .filter(option => option.searchLabel.includes(searchTerm))
                .slice(0, 100) // Limit results for better performance
                .map(option => ({
                    ...option,
                    isDisabled: option.value === selectedPOL
                }));

            callback(filtered);
        }, 500), // Increased debounce time for better performance
        [memoizedLocationOptions, shipmentDetailsFormik.values.location_from?.value]
    );


    useEffect(() => {
        //console.log(activeQuotationsViewDetails, "activeQuotationsViewDetails")
        //console.log(isApplyingBid, "isApplyingBid");
        if (isApplyingBid || isAdditionalCharge) {

            if (activeQuotationsViewDetails != null) {
                shipmentDetailsFormik.setFieldValue('incoterms', incoterm.find(item => item.value === activeQuotationsViewDetails?.incotermId));
                shipmentDetailsFormik.setFieldTouched("incoterms", true);
            }

            if (activeQuotationsViewDetails?.commodityId) {
                shipmentDetailsFormik.setFieldValue('commodity', commodity_data.find(item => Number(item.id) === Number(activeQuotationsViewDetails?.commodityId)));
            }

            if (activeQuotationsViewDetails?.inquiryField != null && tabName === 'FCL') {

                const inquiryField = activeQuotationsViewDetails?.inquiryField;
                const originType = inquiryField?.originType;
                const destinationType = inquiryField?.destinationType;


                const originId = originType === 'CITY'
                    ? inquiryField?.originCityId
                    : originType === 'ICD'
                        ? inquiryField?.originIcdId
                        : inquiryField?.originPortId;

                const originLocationType = originType === 'OCEAN_PORT' ? 'PORT' : originType;


                const destinationId = destinationType === 'CITY'
                    ? inquiryField?.destinationCityId
                    : destinationType === 'ICD'
                        ? inquiryField?.destinationIcdId
                        : inquiryField?.destinationPortId;

                const destinationLocationType = destinationType === 'OCEAN_PORT' ? 'PORT' : destinationType;

                shipmentDetailsFormik.setFieldValue("location_from", locationOptions.find(item =>
                    Number(item.value) === Number(originId) &&
                    item.locationType === originLocationType
                ));

                shipmentDetailsFormik.setFieldValue("location_to", locationOptions.find(item =>
                    Number(item.value) === Number(destinationId) &&
                    item.locationType === destinationLocationType
                ));

                //console.log(container_data, "container_data");
                //console.log(activeQuotationsViewDetails?.inquiryField?.containerDetails, "activeQuotationsViewDetails?.inquiryField?.containerDetails");

                let containerDetails = [];
                activeQuotationsViewDetails?.inquiryField?.containerDetails?.map(item => {
                    containerDetails.push({ containerType: container_data.find(data => Number(data.id) === Number(item.id)), quantity: item.noOfUnits, weight: item.weight });
                });
                //console.log(containerDetails, "containerDetails");
                shipmentDetailsFormik.setFieldValue('containers', containerDetails);
                shipmentDetailsFormik.setFieldValue("cargoValue", activeQuotationsViewDetails?.cargoValue || '0');
            }

            if (activeQuotationsViewDetails?.inquiryField != null && tabName === 'intl_Air') {
                const inquiryField = activeQuotationsViewDetails?.inquiryField;

                const originId = inquiryField?.originPortId;
                const destinationId = inquiryField?.destinationPortId;

                shipmentDetailsFormik.setFieldValue("location_from", airLocation.find(item =>
                    Number(item.id) === Number(originId)
                ));

                shipmentDetailsFormik.setFieldTouched("location_from", true);

                shipmentDetailsFormik.setFieldValue("location_to", airLocation.find(item =>
                    Number(item.id) === Number(destinationId)
                ));

                shipmentDetailsFormik.setFieldTouched("location_to", true);

                let containerDetails = [];
                activeQuotationsViewDetails?.inquiryField?.shipmentDetails?.map(item => {
                    //containerDetails.push({ containerType: container_data.find(data => Number(data.id) === Number(item.id)), quantity: item.noOfUnits, weight: item.weight });
                    containerDetails.push({
                        no_unit: item.noOfUnits,
                        weightPerUnit: item.weightPerUnit,
                        dimensions_l: item.length,
                        dimensions_w: item.width,
                        dimensions_h: item.height,
                        dimensions_unit: 'CM',
                        v_weight: item.v_weight
                    });
                });

                shipmentDetailsFormik.setFieldValue('airContainers', containerDetails);
                shipmentDetailsFormik.setFieldValue("cargoValue", activeQuotationsViewDetails?.cargoValue || '0');
                shipmentDetailsFormik.setFieldValue("totalActualWeight", activeQuotationsViewDetails?.inquiryField?.actualWeight || '0');
                shipmentDetailsFormik.setFieldValue("totalVolumeWeight", activeQuotationsViewDetails?.inquiryField?.volumetricWeight || '0');
            }
        }
    }, [activeQuotationsViewDetails, instantRateLocation, airLocation]);

    useEffect(() => {
        console.log(shipmentDetailsFormik.errors, "shipmentDetailsFormik.errors");
    }, [shipmentDetailsFormik.errors]);

    useEffect(() => {
        console.log(shipmentDetailsFormik.values, "shipmentDetailsFormik.values");
    }, [shipmentDetailsFormik.values]);

    return (
        <div className='charges_wrap'>
            <Row>
                <Col md={6}>
                    <div className="mb-3">
                        <label className="form-label">Origin Port/City<span
                            className='required_star'>*</span></label>
                        <div className='field_wrap'>
                            <AsyncSelect
                                key="pol-select"
                                id="location_from"
                                name="location_from"
                                cacheOptions
                                defaultOptions
                                isClearable
                                loadOptions={loadPolOptions}
                                value={shipmentDetailsFormik.values.location_from || null}
                                onChange={(option) => {
                                    shipmentDetailsFormik.setFieldValue("location_from", option);
                                }}
                                onBlur={() => shipmentDetailsFormik.setFieldTouched("location_from", true)}
                                placeholder="Type to search POL..."
                                formatOptionLabel={({ label, locationType, isDisabled }, { context }) =>
                                    context === 'menu' ? (
                                        <div className="d-flex align-items-center">
                                            <span className="me-1">
                                                <img src={locationType === 'CITY' ? pickup_icon5 : pickup_icon} alt="Location" />
                                            </span>
                                            <span style={{ opacity: isDisabled ? 0.4 : 1 }}>{label}</span>
                                        </div>
                                    ) : <span style={{ opacity: isDisabled ? 0.4 : 1 }}>{label}</span>
                                }
                                classNamePrefix="form-select"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: isApplyingBid || isAdditionalCharge ? 'white' : 'white',
                                        borderColor: !shipmentDetailsFormik.errors.location_to ? 'grey' : 'red',
                                        cursor: isApplyingBid || isAdditionalCharge ? 'not-allowed' : 'default',
                                    }),
                                    // Add performance optimizations for menu rendering
                                    menuList: base => ({
                                        ...base,
                                        height: '200px', // Limit height for better performance
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        padding: '8px 12px', // Slightly more compact options
                                        cursor: 'pointer',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: 'black', // 👈 your custom text color
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        color: '#aaa', // optional placeholder color
                                    })
                                }}
                                // Performance optimizations
                                filterOption={null} // Disable client-side filtering (we do it in loadOptions)
                                isSearchable={true}
                                backspaceRemovesValue={true}
                                blurInputOnSelect={true}
                                closeMenuOnSelect={true}
                                menuShouldBlockScroll={false}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                maxMenuHeight={300}
                                loadingMessage={() => "Loading locations..."}
                                noOptionsMessage={() => "No matching locations found"}
                                isDisabled={isApplyingBid || isAdditionalCharge ? true : false}
                            />
                            {shipmentDetailsFormik.touched.location_from &&
                                shipmentDetailsFormik.errors.location_from && (
                                    <div className="text-danger small">
                                        {shipmentDetailsFormik.errors.location_from.label ||
                                            shipmentDetailsFormik.errors.location_from}
                                    </div>
                                )}
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <label className="form-label">Destination Port/City<span
                            className='required_star'>*</span></label>
                        <div className='field_wrap'>
                            <AsyncSelect
                                key="pod-select"
                                id="location_to"
                                name="location_to"
                                cacheOptions
                                defaultOptions
                                isClearable
                                loadOptions={loadPodOptions}
                                value={shipmentDetailsFormik.values.location_to || null}
                                onChange={(option) => shipmentDetailsFormik.setFieldValue("location_to", option)}
                                onBlur={() => shipmentDetailsFormik.setFieldTouched("location_to", true)}
                                placeholder="Type to search POD..."
                                formatOptionLabel={({ label, locationType, isDisabled }, { context }) =>
                                    context === 'menu' ? (
                                        <div className="d-flex align-items-center">
                                            <span className="me-1">
                                                <img src={locationType === 'CITY' ? pickup_icon5 : pickup_icon} alt="Location" />
                                            </span>
                                            <span style={{ opacity: isDisabled ? 0.4 : 1 }}>{label}</span>
                                        </div>
                                    ) : <span style={{ opacity: isDisabled ? 0.4 : 1 }}>{label}</span>
                                }
                                classNamePrefix="form-select"
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: isApplyingBid || isAdditionalCharge ? 'white' : 'white',
                                        borderColor: !shipmentDetailsFormik.errors.location_to ? 'grey' : 'red',
                                        cursor: isApplyingBid || isAdditionalCharge ? 'not-allowed' : 'default',
                                    }),
                                    // Add performance optimizations for menu rendering
                                    menuList: base => ({
                                        ...base,
                                        height: '200px', // Limit height for better performance
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        padding: '8px 12px', // Slightly more compact options
                                        cursor: 'pointer',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: 'black', // 👈 your custom text color
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        color: '#aaa', // optional placeholder color
                                    })
                                }}
                                // Performance optimizations
                                filterOption={null} // Disable client-side filtering (we do it in loadOptions)
                                isSearchable={true}
                                backspaceRemovesValue={true}
                                blurInputOnSelect={true}
                                closeMenuOnSelect={true}
                                menuShouldBlockScroll={false}
                                menuPlacement="auto"
                                menuPosition="fixed"
                                maxMenuHeight={300}
                                loadingMessage={() => "Loading locations..."}
                                noOptionsMessage={() => "No matching locations found"}
                                isDisabled={isApplyingBid || isAdditionalCharge ? true : false}
                            />
                            {shipmentDetailsFormik.touched.location_to &&
                                shipmentDetailsFormik.errors.location_to && (
                                    <div className="text-danger small">
                                        {shipmentDetailsFormik.errors.location_to.label ||
                                            shipmentDetailsFormik.errors.location_to}
                                    </div>
                                )}
                        </div>
                    </div>
                </Col>
                <Col md={3}>
                    <label className="form-label">Cargo Type<span
                        className='required_star'>*</span></label>
                    <div className={`common_dropdwon_btn_wrap focus_custom_div`} tabIndex={0}>
                        <div className="inner mb-2">
                            <div>
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        readOnly={isApplyingBid || isAdditionalCharge ? true : false}
                                        disabled={isApplyingBid || isAdditionalCharge ? true : false}
                                        className={`shadow-none prof_wrap1 w-100 d-flex justify-space-between ${shipmentDetailsFormik.errors.cargoType ? 'error' : ''}`}
                                        tag="div" onClick={() => {
                                            setIsSubOpen(true);
                                        }}>
                                        <div className="con">
                                            <span className={`value ${shipmentDetailsFormik?.values?.cargoType?.label ? 'value_focus' : ''}`}>
                                                {(shipmentDetailsFormik?.values?.cargoType?.label || 'Select Cargo Type')}
                                                {shipmentDetailsFormik?.values?.cargoType?.value?.toLowerCase() === 'hazardous' && classHazardous !== 0 ? (
                                                    <>
                                                        , class: {classHazardous}
                                                    </>
                                                ) : ''}
                                            </span>
                                        </div>
                                        <i className="mdi mdi-chevron-down" />
                                    </DropdownToggle>
                                    {isSubOpen && <DropdownMenu className="dropdown-menu-end quantity_drop_wrap">
                                        <ul className="common_dropdown_wrap quantity_drop_wrap">
                                            {(cargoType_data.filter(data => data.transportMode == "OCEAN")).map(({
                                                value,
                                                label,
                                                version,
                                                id
                                            }, index) => (
                                                <li key={index}
                                                    className={`${shipmentDetailsFormik?.values?.cargoType?.value === value ? 'active' : ''}`}
                                                    onClick={() => {
                                                        handleCargoTypeChange({ value, label, id, version });
                                                        if (value !== 'HAZARDOUS') {
                                                            setIsOpen(true);
                                                            setIsSubOpen(false);
                                                            setClassHazardous(0);
                                                        }
                                                    }}>
                                                    <div className="custom-option">
                                                        <p>{label}</p>
                                                        {value === 'HAZARDOUS' && (
                                                            <div className='d-flex ms-auto'>
                                                                <p className='me-2'>class:</p>
                                                                <div className="quantity_wrap">
                                                                    <button className="minus" onClick={() => {
                                                                        setClassHazardous(prev => prev >= 1 ? prev - 1 : 0)
                                                                    }}><i className='fas fa-minus'></i></button>
                                                                    <input type="number" name={`${value}_class`} id={`${value}_class`}
                                                                        value={classHazardous} onChange={(e) => {
                                                                            setClassHazardous(e.target.value)
                                                                        }} />
                                                                    <button className="plus" onClick={() => {
                                                                        setClassHazardous(prev => prev <= 8 ? prev + 1 : prev)
                                                                    }}><i className=' fas fa-plus'></i></button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </DropdownMenu>}
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </div>
                    <FormFeedback>{shipmentDetailsFormik.errors.cargoType}</FormFeedback>
                    {shipmentDetailsFormik.touched.cargoType && shipmentDetailsFormik.errors.cargoType && <div className="text-danger">{shipmentDetailsFormik.errors.cargoType.label}</div>}
                </Col>

                <Col md={3}>
                    <label className="form-label">Commodity</label>
                    <AsyncSelect
                        id='commodity'
                        name='commodity'
                        cacheOptions
                        defaultOptions
                        loadOptions={commodityOptions}
                        noOptionsMessage={() => `${filteredCount} commodity found`}
                        value={shipmentDetailsFormik?.values.commodity || null}
                        onBlur={() => shipmentDetailsFormik.setFieldTouched('commodity', true)}
                        onChange={(option) => shipmentDetailsFormik.setFieldValue('commodity', option)}
                        placeholder="Type to search commodity..."
                        isDisabled={isApplyingBid || isAdditionalCharge ? true : false}
                    />
                    {shipmentDetailsFormik.touched.commodity && shipmentDetailsFormik.errors.commodity && <div className="text-danger">{shipmentDetailsFormik.errors.commodity.label}</div>}
                </Col>

                <Col md={3}>
                    <label className="form-label">Cargo Value (USD)</label>
                    <Input
                        type="number"
                        minLength={1}
                        maxLength={100000}
                        name="cargoValue"
                        value={shipmentDetailsFormik.values.cargoValue}
                        onChange={shipmentDetailsFormik.handleChange}
                        placeholder="Enter cargo value.."
                        readOnly={isApplyingBid || isAdditionalCharge ? true : false}
                    />
                    {shipmentDetailsFormik.touched.cargoValue && shipmentDetailsFormik.errors.cargoValue && <div className="text-danger">{shipmentDetailsFormik.errors.cargoValue}</div>}
                </Col>

                <Col md={3}>
                    <label className="form-label">Incoterms<span
                        className='required_star'>*</span></label>
                    <div className='field_wrap'>
                        <Select
                            name='incoterms'
                            value={shipmentDetailsFormik?.values.incoterms}
                            onChange={(option) => shipmentDetailsFormik.setFieldValue('incoterms', option)}
                            placeholder="Type to search Incoterms..."
                            options={incoterm}
                            classNamePrefix="form-select"
                            menuPlacement="auto"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: isApplyingBid || isAdditionalCharge ? 'white' : 'white',
                                    borderColor: !shipmentDetailsFormik.errors.incoterms ? 'grey' : 'red',
                                    cursor: isApplyingBid || isAdditionalCharge ? 'not-allowed' : 'default',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: 'black', // 👈 your custom text color
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: '#aaa', // optional placeholder color
                                })
                            }}
                            onBlur={shipmentDetailsFormik.handleBlur}
                            invalid={shipmentDetailsFormik.touched.incoterms && !!shipmentDetailsFormik.errors.incoterms}
                            isDisabled={isApplyingBid || isAdditionalCharge ? true : false}
                        />
                        <FormFeedback>{shipmentDetailsFormik.errors.incoterms}</FormFeedback>
                    </div>
                </Col>
            </Row>
            {tabName === 'intl_Air' && (
                <Row className="mb-3">
                    <Col md={6}>
                        <label htmlFor="weight" className="form-label">Actual Weight</label>
                        <div className="input-group">
                            <input
                                type="number"
                                readOnly={isApplyingBid || isAdditionalCharge ? true : false}
                                disabled={isApplyingBid || isAdditionalCharge ? true : false}
                                value={shipmentDetailsFormik.values.totalActualWeight || ""}
                                className="form-control"
                                id="weight"
                                onChange={(e) => {
                                    const updatedAirContainer = {
                                        ...shipmentDetailsFormik.values.airContainer || {},
                                        weight: e.target.value
                                    };
                                    shipmentDetailsFormik.setFieldValue('airContainer', updatedAirContainer);
                                }}
                            />
                            <div className="input-group-append">
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        className="btn btn-outline-secondary d-flex align-items-center justify-content-between"
                                        style={{ minWidth: "60px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                        tag="button">
                                        {shipmentDetailsFormik.values.weight_unit || "KG"} <i className="mdi mdi-chevron-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end">
                                        {UOM_weight_data.map((item) => (
                                            <DropdownItem
                                                key={item?.id}
                                                onClick={() => {
                                                    shipmentDetailsFormik.setFieldValue('weight_unit', item?.name);
                                                }}
                                            >
                                                {item?.name}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <label htmlFor="v_weight" className="form-label">Vol. weight</label>
                        <div className="input-group">
                            <input
                                type="number"
                                value={shipmentDetailsFormik.values.totalVolumeWeight || ""}
                                className="form-control"
                                id="v_weight"
                                disabled
                            />
                            <div className="input-group-append">
                                <UncontrolledDropdown>
                                    <DropdownToggle
                                        className="btn btn-outline-secondary d-flex align-items-center justify-content-between"
                                        style={{ minWidth: "60px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                        tag="button"
                                        disabled>
                                        {shipmentDetailsFormik.values.weight_unit || "KG"} <i className="mdi mdi-chevron-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end">
                                        {UOM_weight_data.map((item) => (
                                            <DropdownItem
                                                key={item?.id}
                                                onClick={() => {
                                                    shipmentDetailsFormik.setFieldValue('weight_unit', item?.name);
                                                }}
                                            >
                                                {item?.name}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}

            {/* Container Details */}
            {tabName === 'FCL' &&
                shipmentDetailsFormik.values.containers.map((container, index) => (
                    <ContainerRow
                        key={index}
                        index={index}
                        isApplyingBid={isApplyingBid || isAdditionalCharge ? true : false}
                        container={container}
                        onContainerTypeChange={onContainerTypeChange}
                        containerData={container_data}
                        containerTypeOptions={containerTypeOptions}
                        formik={shipmentDetailsFormik}
                        onRemove={handleRemoveContainer}
                        isLast={index === shipmentDetailsFormik.values.containers.length - 1}
                        formError={formError}
                    />
                ))
            }

            {/* Air Container Details */}
            {tabName === 'intl_Air' && shipmentDetailsFormik.values.airContainers &&
                shipmentDetailsFormik.values.airContainers.map((airContainer, index) => (
                    <AirContainerRow
                        key={index}
                        index={index}
                        item={airContainer}
                        isApplyingBid={isApplyingBid || isAdditionalCharge ? true : false}
                        shipmentDetailsValHandler={(value, field, index, isAir) => {
                            const updatedAirContainers = [...shipmentDetailsFormik.values.airContainers];
                            updatedAirContainers[index] = {
                                ...updatedAirContainers[index],
                                [field]: value
                            };

                            // Calculate actual weight if no_unit or weightPerUnit is updated
                            if (['no_unit', 'weightPerUnit'].includes(field)) {
                                const { no_unit, weightPerUnit } = updatedAirContainers[index];
                                if (no_unit && weightPerUnit) {
                                    const actualWeight = parseFloat(no_unit) * parseFloat(weightPerUnit);
                                    updatedAirContainers[index] = {
                                        ...updatedAirContainers[index],
                                        weight: actualWeight.toFixed(2)
                                    };
                                }
                            }

                            // Calculate volume weight if dimensions are updated
                            if (['dimensions_l', 'dimensions_w', 'dimensions_h', 'no_unit'].includes(field)) {
                                const { dimensions_l, dimensions_w, dimensions_h, no_unit, dimensions_unit } = updatedAirContainers[index];
                                if (dimensions_l && dimensions_w && dimensions_h && no_unit) {
                                    let divisor = 6000; // Default for CM
                                    if (dimensions_unit === 'IN') {
                                        divisor = 366;
                                    } else if (dimensions_unit === 'MM') {
                                        divisor = 6000000;
                                    }

                                    const volumeWeight = (dimensions_l * dimensions_w * dimensions_h * no_unit) / divisor;
                                    updatedAirContainers[index] = {
                                        ...updatedAirContainers[index],
                                        v_weight: volumeWeight.toFixed(2)
                                    };
                                }
                            }

                            // Calculate total weight for all containers
                            let totalActualWeight = 0;
                            let totalVolumeWeight = 0;

                            updatedAirContainers.forEach(container => {
                                if (container.weight) {
                                    totalActualWeight += parseFloat(container.weight);
                                }
                                if (container.v_weight) {
                                    totalVolumeWeight += parseFloat(container.v_weight);
                                }
                            });

                            // Update the air containers array
                            shipmentDetailsFormik.setFieldValue('airContainers', updatedAirContainers);

                            // Update the total weights in the form
                            shipmentDetailsFormik.setFieldValue('totalActualWeight', totalActualWeight.toFixed(2));
                            shipmentDetailsFormik.setFieldValue('totalVolumeWeight', totalVolumeWeight.toFixed(2));
                        }}
                        weightUnit={shipmentDetailsFormik.values.weight_unit || 'KG'}
                        onRemove={handleRemoveAirContainer}
                        isLast={index === shipmentDetailsFormik.values.airContainers.length - 1}
                        formik={shipmentDetailsFormik}
                    />
                ))
            }
            {tabName === 'intl_Air' && !shipmentDetailsFormik.values.airContainers && (
                <div className="text-center p-3">
                    <Button
                        color="primary"
                        onClick={() => {
                            shipmentDetailsFormik.setFieldValue('airContainers', [{
                                no_unit: '',
                                weightPerUnit: '',
                                dimensions_l: '',
                                dimensions_w: '',
                                dimensions_h: '',
                                dimensions_unit: 'CM',
                                weight: '',
                                v_weight: ''
                            }]);
                        }}
                    >
                        <i className="bx bx-plus-circle me-1"></i> Add Air Container
                    </Button>
                </div>
            )}

        </div>
    );
};

export default ShipmentDetails;
